import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { FaBuilding } from "react-icons/fa";
import { EnumPages } from './EnumPages';
import privacyLogo from "../assets/images/chica_ordenador.svg";
import userLogo from "../assets/images/chico_escritorio_ordenador.svg";
import verificationsLogo from "../assets/images/formulario_dni_check.svg";
import servicesLogo from "../assets/images/comunicaciones_fisicas_digitales.svg";
import applicationsLogo from "../assets/images/usuario_de_sistema.svg";
import cancelAccountLogo from "../assets/images/cancelar_cuenta.svg";
import entepriseLogo from "../assets/images/oficina.svg";
import cancelEnterpriseLogo from "../assets/images/cancelar_cuenta.svg";
import createEnterpriseLogo from "../assets/images/empresa.svg";
import teamLogo from "../assets/images/tres_avatares.svg";
import unify from "../assets/images/chico_chica_movil.svg";
import auxData from "../assets/images/oficina.svg";
import auxUserData from "../assets/images/sin_resultados.svg";

export const EnumAllowedSSOUserPages = {
    UserData: "UserData",
    UserVerifications: "UserVerifications",
    UserPrivacy: "UserPrivacy",
    EnterpriseCreate: "EnterpriseCreate",
    UserServices: "UserServices",
    UserCancelAccount: "UserCancelAccount",
    UnifyAccounts: "UnifyAccounts",
};

export const EnumAllowedSSOEnterprisePages = {
    UserData: "UserData",
    UserVerifications: "UserVerifications",
    UserPrivacy: "UserPrivacy",
    EnterpriseCreate: "EnterpriseCreate",
    UserServices: "UserServices",
    UserCancelAccount: "UserCancelAccount",
    UnifyAccounts: "UnifyAccounts",
    EnterpriseData: "EnterpriseData",
    EnterpriseVerifications: "EnterpriseVerifications",
    EnterprisePrivacy: "EnterprisePrivacy",
    EnterpriseTeam: "EnterpriseTeam",
    EnterpriseServices: "EnterpriseServices",
    EnterpriseDelete: "EnterpriseDelete",
};

export const EnumAllowedRedirectUserPages = {
    UserData: "UserData",
    UserVerifications: "UserVerifications",
    UserCancelAccount: "UserCancelAccount",
    EnterpriseCreate: "EnterpriseCreate",
    UnifyAccounts: "UnifyAccounts",
};

export const EnumAllowedRedirectEnterprisePages = {
    UserData: "UserData",
    UserVerifications: "UserVerifications",
    UserCancelAccount: "UserCancelAccount",
    EnterpriseCreate: "EnterpriseCreate",
    UnifyAccounts: "UnifyAccounts",
    EnterpriseData: "EnterpriseData",
    EnterpriseVerifications: "EnterpriseVerifications",
    EnterpriseDelete: "EnterpriseDelete",
};

export const EnumEnterprisePages = [
    "EnterpriseData",
    "EnterpriseVerifications",
    "EnterprisePrivacy",
    "EnterpriseTeam",
    "EnterpriseServices",
    "EnterpriseDelete",
];

export const EnumFirstSelectOption = "NOOPTSEL";

export const Size = {
    large: "large",
    medium: "medium",
    small: "small"
};

export const EnumPersonType = {
    User: "User",
    Enterprise: "Enterprise"
};

export const fetchMethod = {
    POST: "POST",
    PUT: "PUT",
    GET: "GET",
    DELETE: "DELETE",
};

export const sessionValues = {
    idToken: "valIdT",
    refreshToken: "refT",
    time: "time",
    appOid: "appV",
    appName: "appN",
    appCode: "appC",
    logged: "logged",
    imageLogin: "imaLog",
    imageRegistry: "imaReg",
    imagePassword: "imaPass",
    allowSignup: "allSign",
    InvitationAccept: "InvAcc",
    AcceptChangeEnterpriseRole: "AccChaEntRol",
    CancelOrRejectChangeRole: "CanOrRejChaRol",
    idInvitation: "idInv",
    originUrl: "oriUrl",
    entranceUrl: "entUrl",
    redirectURI: "redURI",
    replaceMode: "repMod",
    isUserTitular: "isUsTit",
    appPersonType: "appPerTyp",
    attributeInfo: "attInf",
    attributes: "att",
    fieldType: "fieTyp",
    userConfiguration: "userConf",
    enterpriseConfiguration: "entConf",
    offersAndProms: "offAndPro",
    cidPrivacyAndTyc: "cidPriAndTyc",
    pendingData: "penDat",
    state: "state",
    isNoToken: "isNoTok",
    phoneApp: "phoApp",
};

export const secureValues = {
    user: "user",
    userOid: "userV",
    token: "valT",
    enterpriseList: "entList",
    copyUser: "userC"
};

export const generalWarning = {
    pass: "pass",
    registry: "registry",
    verify: "verify",
};

const generalSteps = {
    createUserCid: "createUserCid",
    subscriptionToApp: "subscriptionToApp",
    userIdentify: "userIdentify",
    requiredData: "requiredData",
};

export const generalPaths = {
    Registry: [generalSteps.createUserCid, generalSteps.subscriptionToApp],
    PendingData: [generalSteps.userIdentify, generalSteps.requiredData],
};

export const iconsList = {
    User: {
        1: <PersonOutlineIcon />,
        2: <PersonIcon />,
    },
    Enterprise: {
        1: <PersonOutlineIcon />,
        2: <FaBuilding />,
    },
};

export const verificatedValues = {
    email: 2,
    phone: 5,
};

export const pageTitles = {
    [EnumPages.UserPrivacy]: "mainPagePrivacity",
    [EnumPages.UserData]: "UserData",
    [EnumPages.UserVerifications]: "UserVerifications",
    [EnumPages.UserServices]: "Services",
    [EnumPages.SystemUser]: "SystemUser",
    [EnumPages.UserCancelAccount]: "askUnsubscribeService",
    [EnumPages.EnterpriseData]: "entepriseDataTitle",
    [EnumPages.EnterpriseVerifications]: "UserVerifications",
    [EnumPages.EnterprisePrivacy]: "mainPagePrivacity",
    [EnumPages.EnterpriseServices]: "Services",
    [EnumPages.EnterpriseTeam]: "EnterpriseTeam",
    [EnumPages.EnterpriseDelete]: "askUnsubscribeService",
    [EnumPages.EnterpriseCreate]: "enterpriseCreateTitle",
    [EnumPages.UnifyAccounts]: "unifyAccountsTitle",
};

export const pageSubtitles = {
    [EnumPages.UserPrivacy]: "privacyIntroText",
    [EnumPages.UserData]: "userDataPageSubtitle",
    [EnumPages.UserVerifications]: "verifications2FAImageText",
    [EnumPages.UserServices]: "servicePageSubtitle",
    [EnumPages.SystemUser]: "systemUserPageSubtitle",
    [EnumPages.UserCancelAccount]: "accountCancelDisableAccountAsk",
    [EnumPages.EnterpriseData]: "enterpriseDataSubtitle",
    [EnumPages.EnterpriseVerifications]: "verificationsEnterprisePageSubtitle",
    [EnumPages.EnterprisePrivacy]: "privacyEnterpriseIntroText",
    [EnumPages.EnterpriseServices]: "servicePageEnterpriseSubtitle",
    [EnumPages.EnterpriseTeam]: "teamPageSubtitle",
    [EnumPages.EnterpriseDelete]: "enterpriseDeleteEnterpriseTitleNoName",
    [EnumPages.EnterpriseCreate]: "enterpriseSubtitle",
    [EnumPages.UnifyAccounts]: "unifyAccountsSubTitle",
};

export const pageSubtitles2 = {
    [EnumPages.UserPrivacy]: "privacyIntroText2",
    [EnumPages.UserVerifications]: "verificationsPageSubtitle",
    [EnumPages.UnifyAccounts]: "unifyAccountsSubTitle2",
};

export const pageImage = {
    [EnumPages.UserPrivacy]: privacyLogo,
    [EnumPages.UserData]: userLogo,
    [EnumPages.UserVerifications]: verificationsLogo,
    [EnumPages.UserServices]: servicesLogo,
    [EnumPages.SystemUser]: applicationsLogo,
    [EnumPages.UserCancelAccount]: cancelAccountLogo,
    [EnumPages.EnterpriseData]: entepriseLogo,
    [EnumPages.EnterpriseVerifications]: verificationsLogo,
    [EnumPages.EnterprisePrivacy]: privacyLogo,
    [EnumPages.EnterpriseServices]: servicesLogo,
    [EnumPages.EnterpriseTeam]: teamLogo,
    [EnumPages.EnterpriseDelete]: cancelEnterpriseLogo,
    [EnumPages.EnterpriseCreate]: createEnterpriseLogo,
    [EnumPages.UnifyAccounts]: unify,
    [EnumPages.AuxEnterpriseData]: auxData,
    [EnumPages.AuxUserData]: auxUserData,
};

export const iconNames = {
    delete: "delete",
    privacy: "privacy",
    document: "document",
    email: "email",
    link: "link",
    address: "address",
    services: "services",
    lock: "lock",
    logOut: "logOut",
    more: "more",
    phone: "phone",
    status: "status",
    app: "app",
    user: "user",
    enterprise: "enterprise",
    cancel: "cancel",
    city: "city",
    world: "world",
    mail: "mail",
    verify: "verify",
    prueba: "prueba",
    pruebaMatri: "pruebaMatri",
    editar: "editar",
    addUser: "addUser",
    createAdm: "createAdm",
    personal: "personal",
    anadirIcon: "anadirIcon",
    change: "change",
};

export const EnumPrivacyTyC = {
    GeneralUseConditions:"CGU",
    DataProtectionPolicy:"PPD",
};
